<template>
  <div class="chip-wrapper">
    <div class="custom-chip headline">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionTitle',
  props: {
    title: String,
  },
};
</script>

<style scoped>
.chip-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}
.custom-chip {
  width: 150px;
  background: #257439;
  color: white;
  border-radius: 10px;
}
</style>
